import { Button } from '@moniebook-web/components/atoms/button';
import { Body, Title } from '@moniebook-web/components/atoms/typography';
import { OnboardingLayout } from '@register-ui/components';
import { type PropsWithChildren } from 'react';
import { useDeviceTimeGuard } from './use-device-time-guard';

export function DeviceTimeGuard(props: Readonly<PropsWithChildren>) {
    const { hasWrongTimeSettings, display } = useDeviceTimeGuard();

    if (!hasWrongTimeSettings) {
        return props.children;
    }

    return (
        <OnboardingLayout actions={[]}>
            <div className='mb-60 flex flex-1 animate-fade-in flex-col items-center justify-center gap-32 text-center'>
                <img
                    src='/illustrations/support-request-default.svg'
                    alt='Unsupported device'
                    className='h-120 w-240'
                />

                <div className=''>
                    <Title className='mb-8 font-general-sans font-semibold'>
                        Your device's date or time is incorrect.
                    </Title>

                    <p className='font-normal text-content-subtext-default'>
                        Please adjust it and refresh the page to continue using
                        Moniebook.
                    </p>
                </div>

                {!!display && (
                    <div className='flex w-380 max-w-full flex-col gap-10 rounded-8 bg-neutral-s20 px-16 py-12 text-left'>
                        <div className='flex justify-between'>
                            <Body className='text-content-subtext-alternative'>
                                Expected Time
                            </Body>

                            <Body className='font-general-sans tracking-wide text-content-body-default'>
                                {display.server} (UTC)
                            </Body>
                        </div>

                        <div className='flex justify-between'>
                            <Body className='text-content-subtext-alternative'>
                                Your device's time
                            </Body>

                            <Body className='font-general-sans tracking-wide text-content-body-default'>
                                {display.device} (UTC)
                            </Body>
                        </div>
                    </div>
                )}

                <Button
                    onClick={() => window.location.reload()}
                    label='Refresh page'
                />
            </div>
        </OnboardingLayout>
    );
}
